import _debounce from 'lodash/debounce'

const SPELLCHECK_DEBOUNCE_DELAY = 10000
const isValidMisspelledWord = (misspelledWord) => {
  // return misspelledWord?.context?.includes(misspelledWord.word) && misspelledWord?.suggestions?.length
  return misspelledWord?.context?.includes(misspelledWord.word)
}

const formatWords = ({ misspelledWord }) => {
  let words = misspelledWord?.context?.split(' ')?.map((word) => ({
    text: word,
    // correction: word?.includes(misspelledWord.word) ? misspelledWord.suggestions[0] : '',
    isMisspelled: word?.includes(misspelledWord.word),
  }))

  // Add `...` before the first word if it is not capitalized
  if (words?.length > 0 && !words[0]?.text?.charAt(0)?.match(/[A-Z]/)) {
    // words = [{ text: '...', correction: '', isMisspelled: false }, ...words]
    words = [{ text: '...', isMisspelled: false }, ...words]
  }

  // Add `...` after the last word
  if (words?.length > 0) {
    // words.push({ text: '...', correction: '', isMisspelled: false })
    words.push({ text: '...', isMisspelled: false })
  }

  return words
}

const correctMisspell = (slide, misspelledWord, correction) => {
  if (typeof slide !== 'object' || slide === null) return slide

  Object.entries(slide).forEach(([key, value]) => {
    if (typeof value === 'object' && value !== null) {
      correctMisspell(value, misspelledWord, correction) // Recursive call for nested objects
    } else if (typeof value === 'string' && value.includes(misspelledWord)) {
      slide[key] = value.replace(new RegExp(misspelledWord, 'g'), correction)
    }
  })

  return slide
}

const formatSlideArrays = (slide) => {
  // JSON.stringify `otherCorrectQuiz` if it's an array
  if (Array.isArray(slide.otherCorrectQuiz)) {
    slide.otherCorrectQuiz = JSON.stringify(slide.otherCorrectQuiz)
  }

  // JSON.stringify `additionalFields` if it's an array
  if (Array.isArray(slide.additionalFields)) {
    slide.additionalFields = JSON.stringify(slide.additionalFields)
  }
}

export const getCorrectedSlideProperties = ({
  slide, misspelledWord, correction,
}) => {
  if (!slide?.id || !misspelledWord?.length || !correction?.length) return slide

  correctMisspell(slide, misspelledWord, correction)
  formatSlideArrays(slide)

  return slide
}

export const formatMisspells = ({ misspells }) => {
  if (!misspells?.length) return []

  return misspells.flatMap((entry) => entry.misspelled
    .filter(isValidMisspelledWord)
    .map((misspelledWord) => {
      const words = formatWords({ misspelledWord })

      return {
        id: entry.mapping_id,
        slideId: entry.slideId,
        partialPhrase: misspelledWord.context,
        misspelledWord: misspelledWord.word,
        // corrections: misspelledWord.suggestions?.splice(0, 3),
        activeCorrectionIndex: 0,
        words,
      }
    }))
}

export const debouncedFetchMisspells = _debounce((dispatch, presentationId) => {
  if (presentationId) {
    dispatch('spellchecker/fetchMisspellListAction', presentationId, { root: true })
  }
}, SPELLCHECK_DEBOUNCE_DELAY)
